import { PROFFEO_CHART_COLORS } from '@app/shared/ui/tokens/chart.tokens';

export const CHART_SCALE_CONSTANTS = {
  STANDARD_WORK_HOURS: 7.5,
  SINGLE_USER_DAY_MAX: 12.5,
  SINGLE_USER_WEEK_MAX: 60,
  SINGLE_USER_MONTH_MAX: 250,
  YEAR_SCALE_ROUNDING: 100,
  YEAR_SCALE_MARGIN: 100,
  DEFAULT_MARGIN_PERCENT: 0.1,
  MIN_MARGIN: 2,
  LABEL_THRESHOLD_MANY: 2,
  LABEL_COUNT_THRESHOLD: 12
} as const;

export const HOURS_TYPE_COLORS = {
  STANDARD: PROFFEO_CHART_COLORS.standard,
  BANK_PLUS: PROFFEO_CHART_COLORS.bankPlus,
  OVERTIME_50: PROFFEO_CHART_COLORS.overtime50,
  OVERTIME_100: PROFFEO_CHART_COLORS.overtime100,
  BASE: 'rgba(54, 162, 235, 0.8)',
  OVERTIME: 'rgba(255, 99, 132, 0.8)'
} as const;

export const HOURS_TYPE_LABELS = {
  TOTAL: 'Total',
  STANDARD: 'Ord.',
  BANK_PLUS: 'Bank+',
  BANK_MINUS: 'Bank-',
  OVERTIME_50: '50%',
  OVERTIME_100: '100%',
  BASE_HOURS: 'Base Hours',
  OVERTIME: 'Overtime'
} as const;
